import React from 'react';
import { useLocation } from 'umi';
import {
  MilestoneDocPreviewer,
  UpdatesDocPreviewer,
  DPSReportMemoDocPreviewer,
  OverviewDocPreviewer,
} from './components';
import usePageLog from '@gp/hooks/usePageLog';

import type { IRecord } from '@gp/types/global';

// previewers映射
const PREVIEWERS: Record<string, React.FC<any>> = {
  milestone_materials: MilestoneDocPreviewer,
  updates_materials: UpdatesDocPreviewer,
  dps_report_memo_materials: DPSReportMemoDocPreviewer,
  overview_mandate: OverviewDocPreviewer,
};

// previews页面打点映射
const PREVIEWERS_LOGS: Record<string, string> = {
  milestone_materials: 'MILESTONE_DOC_PREVIEWER',
  updates_materials: 'UPDATES_DOC_PREVIEWER',
  dps_report_memo_materials: 'DPS_REPORT_MEMO_DOC_PREVIEWER',
  overview_mandate: 'DPS_REPORT_MEMO_DOC_PREVIEWER',
};

/**
 * 解析查询参数
 * @param search 查询参数字符串
 * @returns 查询参数对象
 */
const analysisSearchParams = (
  search: string,
): {
    previewer_type:
    | 'milestone_materials'
    | 'updates_materials'
    | 'dps_report_memo_materials'
    | 'overview_mandate'
    | (string & {});
    [key: string]: any;
  } => {
  const searchParams = new URLSearchParams(search);
  const others: IRecord<any> = {};

  searchParams.forEach((value, key) => {
    if (key === 'previewer_type') return;
    others[key] = value;
  });

  return { ...others, previewer_type: searchParams.get('previewer_type') || '' };
};

// previewer识别失败时的兜底展示
const UnknownPreviewer: React.FC = () => <div style={{ margin: 20, textAlign: 'center' }}>Unknown Previewer</div>;

const COSPreviewers: React.FC = () => {
  const location = useLocation();
  const { previewer_type: previewerType, ...restParams } = analysisSearchParams(location.search);
  const Previewer = PREVIEWERS[previewerType] || UnknownPreviewer;

  usePageLog({
    pageId: PREVIEWERS_LOGS[previewerType],
    extInfo: restParams?.doc_key || '',
  });

  return (
    <div className="dbg-cos-previewers">
      <Previewer {...restParams} />
    </div>
  );
};

export default COSPreviewers;
